var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfilePig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1346,
    height: 948,
    viewBox: "0 0 1346 948",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M673 296.007L475.438 156.623C475.438 156.623 174.236 -12.9852 159.844 156.623C145.451 326.231 228.925 491.95 228.925 491.95L398.747 638.747L673 296.007Z",
    fill: "#F9A6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M576.114 304.675L436.172 205.943C436.172 205.943 222.817 85.8016 212.622 205.943C202.427 326.084 261.555 443.471 261.555 443.471L381.848 547.453L576.114 304.675Z",
    fill: "#F37097"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M673 296.007L870.562 156.623C870.562 156.623 1171.76 -12.9852 1186.16 156.623C1200.55 326.231 1117.07 491.95 1117.07 491.95L947.252 638.747L673 296.007Z",
    fill: "#F9A6BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M758 304.675L897.942 205.943C897.942 205.943 1111.3 85.8016 1121.49 205.943C1131.69 326.084 1072.56 443.471 1072.56 443.471L952.265 547.453L758 304.675Z",
    fill: "#F37097"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1147 631.032C1147 897 887.434 949.554 661.102 947C438.617 944.489 187 920.999 187 631.032C187 341.065 397.668 127 661.102 127C924.537 127 1147 341.065 1147 631.032Z",
    fill: "#F9A6BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M338 524C338 485.892 368.892 455 407 455V455C445.107 455 476 485.892 476 524V524C476 562.108 445.107 593 407 593V593C368.892 593 338 562.108 338 524V524Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M338 524C338 485.892 368.892 455 407 455V455C445.107 455 476 485.892 476 524V524C476 562.108 445.107 593 407 593V593C368.892 593 338 562.108 338 524V524Z",
    fill: "#151414"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M449 727.468C449 635.55 511.515 553.629 602.72 542.193C627.612 539.072 652.307 537 674 537C695.692 537 720.387 539.072 745.279 542.193C836.484 553.629 899 635.55 899 727.468V740.5V740.5C899 834.112 823.112 910 729.5 910H674H618.5C524.887 910 449 834.112 449 740.5V740.5V727.468Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M449 727.468C449 635.55 511.515 553.629 602.72 542.193C627.612 539.072 652.307 537 674 537C695.692 537 720.387 539.072 745.279 542.193C836.484 553.629 899 635.55 899 727.468V740.5V740.5C899 834.112 823.112 910 729.5 910H674H618.5C524.887 910 449 834.112 449 740.5V740.5V727.468Z",
    fill: "#CC748F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M533 700.5C533 675.371 553.371 655 578.5 655V655C603.628 655 624 675.371 624 700.5V747.5C624 772.629 603.628 793 578.5 793V793C553.371 793 533 772.629 533 747.5V700.5Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M533 700.5C533 675.371 553.371 655 578.5 655V655C603.628 655 624 675.371 624 700.5V747.5C624 772.629 603.628 793 578.5 793V793C553.371 793 533 772.629 533 747.5V700.5Z",
    fill: "#7E4E5D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M716 700.5C716 675.371 736.371 655 761.5 655V655C786.628 655 807 675.371 807 700.5V747.5C807 772.629 786.628 793 761.5 793V793C736.371 793 716 772.629 716 747.5V700.5Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M716 700.5C716 675.371 736.371 655 761.5 655V655C786.628 655 807 675.371 807 700.5V747.5C807 772.629 786.628 793 761.5 793V793C736.371 793 716 772.629 716 747.5V700.5Z",
    fill: "#7E4E5D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M872 524C872 485.892 902.892 455 941 455C979.107 455 1010 485.892 1010 524C1010 562.108 979.107 593 941 593C902.892 593 872 562.108 872 524Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M872 524C872 485.892 902.892 455 941 455C979.107 455 1010 485.892 1010 524C1010 562.108 979.107 593 941 593C902.892 593 872 562.108 872 524Z",
    fill: "#151414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfilePig);
export default __webpack_public_path__ + "static/media/default-profile-pig.ddf052d8.svg";
export { ForwardRef as ReactComponent };